module.exports = __webpack_public_path__ + "static/media/10.6051de8b.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/accessoires/10.png
// module id = 376
// module chunks = 0